import { makeHttpParamExtractor } from "../http-param-extractor.js";
import { parseRequestMetadataExtensions } from "./request-metadata-extensions.js";
const extractFirstIp = (ipList) => {
    const ips = ipList.split(",").map((ip) => ip.trim());
    return ips[0] || "";
};
export const extractRequestMetadata = (req, query) => {
    const headers = makeHttpParamExtractor(req.headers);
    const q = query ? makeHttpParamExtractor(query) : () => undefined;
    return {
        // note: X-Forwarded-For should be filtered by reverse proxy to avoid spoofing!
        ip: extractFirstIp(headers("x-forwarded-for") || "") ||
            req.socket.remoteAddress ||
            "0.0.0.0",
        userAgent: headers("user-agent") || "",
        referer: headers("referer") || "",
        host: headers("host") || "",
        ext: parseRequestMetadataExtensions(req.headers),
        tr: query
            ? {
                utm_campaign: q("utm_campaign"),
                utm_source: q("utm_source"),
                utm_medium: q("utm_medium"),
                utm_term: q("utm_term"),
                utm_content: q("utm_content"),
                gclid: q("gclid"),
                ttclid: q("ttclid"),
                fbclid: q("fbclid"),
            }
            : undefined,
    };
};
